




































































import Vue from 'vue'
import { IHit } from '../store/state'

interface HitProps {
	hit: IHit
}

interface HitMethods {
	isFile(hit: IHit): boolean
	fileType(hit: IHit): string
}

export default Vue.extend<{}, HitMethods, {}, HitProps>({
	name: 'Hit',
	props: {
		hit: {}
	},
	methods: {
		isFile(hit) {
			return hit.svType === 'file'
		},
		fileType(hit) {
			return hit.fileType
		}
	}
})
